import { X } from "lucide-react";
import React, { useEffect, useState } from "react";
import { apiClient } from "../../api";
import { baseUrl } from "../../Environments/environment";
import { LocalStorage } from "../../utils";
import { ThreeDot } from "react-loading-indicators";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

const RepliesListModal = ({ review, onClose }) => {
//   const replies = [
//     {
//       id: 1,
//       text: "Thank you for your feedback!",
//       date: "2025-05-06T14:30:00Z",
//     },
//     { id: 2, text: "We’ve resolved the issue.", date: "2025-05-06T16:45:00Z" },
//     {
//       id: 3,
//       text: "Appreciate your suggestion!",
//       date: "2025-05-07T08:10:00Z",
//     },
//     {
//       id: 4,
//       text: "We'll definitely improve this area.",
//       date: "2025-05-07T10:15:00Z",
//     },
//     {
//       id: 5,
//       text: "Glad you liked the service!",
//       date: "2025-05-07T12:05:00Z",
//     },
//     {
//       id: 6,
//       text: "Your feedback has been shared with our team.",
//       date: "2025-05-07T13:45:00Z",
//     },
//     {
//       id: 7,
//       text: "Thanks! We're working on adding that feature soon.",
//       date: "2025-05-07T15:20:00Z",
//     },
//   ];
  const [isLoading,setIsLoading] = useState(false);
  const [replies,setReplies] = useState();

  async function fetchReplies() {
    try {
      setIsLoading(true);
      const token = LocalStorage.get("accessToken");
      const propertyId = localStorage.getItem("selectedPropertyId");
      console.log("PropertyId :- ",propertyId);
      console.log("Token :- ",token)
      const response = await apiClient.get(
        `${baseUrl}/reply/review/${propertyId}/${review._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Reviews :- ", response.data);
      setReplies(response.data.result.replies);
      //setReviews(response.data.result.reviews);
    } catch (e) {
      console.error("Error Fetching Reviews :- ", e);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchReplies();
    console.log("Selected Review :- ", review._id);
  }, []);

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
  <div className="bg-white w-full max-w-lg max-h-[80vh] rounded-xl shadow-xl overflow-hidden flex flex-col">
    {isLoading ? (
      
      // <div className="flex items-center justify-center h-full p-8">
        // <p className="text-gray-500 text-sm">Loading replies...</p>
        <LoadingSpinner/>
        // {/* Or replace <p> with a spinner like <Spinner /> */}
      // </div>
    ) : (
      <>
        {/* Modal Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b bg-gray-50">
          <h2 className="text-lg font-bold text-gray-800">Replies</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-red-500"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Modal Body */}
        <div className="p-4 overflow-y-auto">
          {replies && replies.length > 0 ? (
            replies.map((reply) => (
              <div
                key={reply._id}
                className="bg-white border border-gray-200 shadow-sm rounded-lg p-4 mb-3 transition hover:shadow-md"
              >
                <p className="text-gray-800 text-sm mb-2">{reply.reply}</p>
                <p className="text-xs text-gray-500">
                  {new Date(reply.createdAt).toLocaleString()}
                </p>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500">No replies available.</p>
          )}
        </div>
      </>
    )}
  </div>
</div>
  );
};

export default RepliesListModal;
